module.exports = __webpack_public_path__ + "img/9.1b00bdbb.png";